import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function useRouteFocus() {
  const location = useLocation();
  const lastPathnameRef = useRef(null);

  useEffect(() => {
    if (lastPathnameRef.current === null) {
      lastPathnameRef.current = location.pathname;
      return undefined;
    }

    // In React StrictMode (dev), effects run twice on mount. Skip if no real route change.
    if (lastPathnameRef.current === location.pathname) {
      return undefined;
    }
    lastPathnameRef.current = location.pathname;

    const focusTarget = () => {
      const main =
        document.getElementById("main-content") ||
        document.querySelector("main");
      if (!main) return;

      const heading =
        main.querySelector("[data-page-heading='true']") ||
        main.querySelector("h1");

      const target = heading || main;
      if (!(target instanceof HTMLElement)) return;
      if (!target.hasAttribute("tabindex")) {
        target.setAttribute("tabindex", "-1");
      }
      target.setAttribute("data-route-focus-target", "true");
      // Preserve explicit scroll-to-top behavior on route changes.
      try {
        target.focus({ preventScroll: true });
      } catch {
        target.focus();
      }
    };

    const rafId = window.requestAnimationFrame(focusTarget);
    return () => window.cancelAnimationFrame(rafId);
  }, [location.pathname]);
}
